import { FormTouristsPicker } from './FormTouristsPicker';

export default FormTouristsPicker;
